// extracted by mini-css-extract-plugin
export default {"wrapper":"Talking_wrapper__rju2o","left":"Talking_left__Ba34c","right":"Talking_right__uJCrr"};